const CSV_HEADERS = ['first_name', 'last_name', 'email', 'password', 'role', 'groups'];

const parseCsvLine = (line) => {
  const values = [];
  let current = '';
  let inQuotes = false;

  for (let index = 0; index < line.length; index += 1) {
    const char = line[index];
    const nextChar = line[index + 1];

    if (char === '"') {
      if (inQuotes && nextChar === '"') {
        current += '"';
        index += 1;
      } else {
        inQuotes = !inQuotes;
      }
      continue;
    }

    if (char === ',' && !inQuotes) {
      values.push(current.trim());
      current = '';
      continue;
    }

    current += char;
  }

  values.push(current.trim());
  return values;
};

export const parseUsersCsv = (csvText) => {
  const lines = csvText
    .replace(/^\uFEFF/, '')
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  if (lines.length < 2) {
    throw new Error('CSV file must include a header row and at least one data row.');
  }

  const headers = parseCsvLine(lines[0]).map((header) => header.toLowerCase());
  const missingHeaders = CSV_HEADERS.filter((header) => !headers.includes(header));

  if (missingHeaders.length > 0) {
    throw new Error(`Missing required column(s): ${missingHeaders.join(', ')}`);
  }

  return lines.slice(1).map((line) => {
    const values = parseCsvLine(line);
    const record = {};

    headers.forEach((header, index) => {
      record[header] = values[index] ?? '';
    });

    return {
      first_name: record.first_name || '',
      last_name: record.last_name || '',
      email: record.email || '',
      password: record.password || '',
      role: record.role || '',
      groups: record.groups || ''
    };
  });
};

export const buildUsersCsvTemplate = (roles = []) => {
  const instructorRole = roles.find((role) => parseInt(role.value) > 2);
  const learnerRole = roles.find((role) => parseInt(role.value) === 1);

  const headerLine = CSV_HEADERS.join(',');
  const sampleLearnerRole = learnerRole?.name || 'Individual User';
  const sampleInstructorRole = instructorRole?.name || 'Instructor';

  const sampleRows = [
    `John,Doe,john.doe@example.com,Password123,${sampleLearnerRole},Group A;Group B`,
    `Jane,Smith,jane.smith@example.com,Password123,${sampleInstructorRole},Group A`
  ];

  return [headerLine, ...sampleRows].join('\n');
};

export const USER_CSV_HEADERS = CSV_HEADERS;
